import {ClassPlayerConfig} from "./ClassPlayerConfig";
import {LoopParameters} from "../../../../player/models/parameters/LoopParameters";
import {VisualParameters} from "../../../../player/models/parameters/VisualParameters";
import {
  defaultVolumes,
  SoundParameters,
  SoundParametersActiveConfiguration
} from "../../../../player/models/parameters/SoundParameters";
import {playablePool} from "../../../../playable/utils/PlayablePool";
import {playableTypeFromLoopType} from "../../../../global/types/GlobalTypes";
import {ListPlayableContent} from "../../../../playable/models/ListPlayableContent";
import {AbstractPlayableContent} from "../../../../playable/models/AbstractPlayableContent";

export interface ClassStepTransitionContent {
  title: string,
  description: string,
}
export interface ClassStepTransition {
  before: ClassStepTransitionContent,
  after: ClassStepTransitionContent|null,
}

export interface ClassStep {
  readonly id: number;
  readonly name: string;
  readonly shortName: string;
  readonly localName: Record<'fr' | 'en', string>;
  readonly localShortName: Record<'fr' | 'en', string>;
  readonly transitions: ClassStepTransition;

  readonly isOptional: boolean;
  readonly requireValidation: boolean; // Before : validate, should we keep it or move it to playerMode ? More globally is playerMode validation still useful ?

  readonly playerConfig: ClassPlayerConfig;
}

export function createClassStepsFromJsonArray(steps: []): ClassStep[] {
  const classSteps = [] as ClassStep[];

  steps.forEach((step) => {
    classSteps.push(createStepClassFromJson(step));
  })

  return classSteps;
}
function createStepClassFromJson(jsonStep: any): ClassStep {
  const soundActiveConfiguration: SoundParametersActiveConfiguration = {
    MAIN: true,
    LEFT: jsonStep.playerConfiguration.soundParameters.isLeftSoundActive,
    RIGHT: jsonStep.playerConfiguration.soundParameters.isRightSoundActive,
    MELODY: jsonStep.playerConfiguration.soundParameters.isMelodySoundActive,
    METRONOME: jsonStep.playerConfiguration.soundParameters.isMetronomeActive,
  }
  return {
    id: jsonStep.id,
    name: jsonStep.name,
    shortName: jsonStep.shortName,
    localName: jsonStep.localName,
    localShortName: jsonStep.localShortName,
    transitions: jsonStep.transitions,
    isOptional: jsonStep.isOptional,
    requireValidation: jsonStep.requireValidation,
    playerConfig: {
      playerMode: jsonStep.playerConfiguration.playerMode,
      playerView: jsonStep.playerConfiguration.playerView,
      startTempo: jsonStep.playerConfiguration.classTempoType,
      visualParameters: new VisualParameters({
        'LEFT': jsonStep.playerConfiguration.visualParameters.isLeftHandDisplayed,
        'RIGHT': jsonStep.playerConfiguration.visualParameters.isRightHandDisplayed,
        'LYRICS': jsonStep.playerConfiguration.visualParameters.isLyricsDisplayed,
      }),
      loopParameters: createLoopParametersForJsonStep(jsonStep.playerConfiguration.loopParameters),
      soundParameters: new SoundParameters(soundActiveConfiguration, defaultVolumes),
    }
  }
}

function createLoopParametersForJsonStep(jsonLoopParameters: any) {
  // Case of consolidation steps
  let playableContent: AbstractPlayableContent;
  if (jsonLoopParameters.type === 'LIST') {
    if (!playablePool.exists('version', jsonLoopParameters.playableId, jsonLoopParameters.extra.poolIndex)) {
      const playableTimeline = jsonLoopParameters.extra.timeline.map((id: number, index: number) => {
        return playablePool.get('part', id, jsonLoopParameters.extra.startIndexInParent + index)!
      })

      // TODO Type must be dynamic in case we send a part list for instance
      playableContent = new ListPlayableContent(playablePool.get('version', jsonLoopParameters.playableId)!, playableTimeline);
      playablePool.add(playableContent, jsonLoopParameters.extra.poolIndex, 'list', playableTimeline[0].id);
    }
    else {
      playableContent = playablePool.get('version', jsonLoopParameters.playableId, jsonLoopParameters.extra.poolIndex)!
    }
  }
  else {
    playableContent = playablePool.get(playableTypeFromLoopType(jsonLoopParameters.type), jsonLoopParameters.playableId, jsonLoopParameters.playableIndex)!
  }

  return new LoopParameters(jsonLoopParameters.type, playableContent);
}

